import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignMagazineAnalyticsSettingContainer } from "@/components/features/design/magazine/setting";

import { useGetParams } from "./hooks/use-get-params";

export const DesignMagazineSettingPage = () => {
	const { hotelID } = useGetParams();

	return (
		<PageMeta
			title="マガジン記事の一覧 | マガジンの設定"
			url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.SETTING, { hotelID })}
		>
			<DesignMagazineAnalyticsSettingContainer hotelID={hotelID} />
		</PageMeta>
	);
};

DesignMagazineSettingPage.displayName = "DesignMagazineSettingPage";
